import { LoadingState, SHOW_LOADING, HIDE_LOADING } from '@store/loading/types';

const initialState: LoadingState = {
  open: false,
};

// Reducer
export default function loadingReducer(state = initialState, action: { type: string }): LoadingState {
  switch (action.type) {
    case SHOW_LOADING:
      return { open: true };
    case HIDE_LOADING:
      return { open: false };
    default:
      return state;
  }
}
export const showLoading = () => ({ type: SHOW_LOADING } as const);
export const hideLoading = () => ({ type: HIDE_LOADING } as const);
